import React, { useState,useEffect } from "react";
import { MdSmartToy, MdVisibility, MdVisibilityOff,MdChat,MdPolicy,MdArrowBack  } from "react-icons/md";
import { styles } from "../styles/AIAssistantForm.styles";
import { createIAConfig } from "../services/ia";
import { useAuth } from "../context/AuthContext";
import Select from "react-select";
import { IoReceiptSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

function AIAssistantForm({ onSubmit, onCancel, isLoading, setActiveMenu,isMobile }) {
  const [open, setOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const { token, stampTomador } = useAuth(); 
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: "",
    foto: null,
    fotoPreview: null,
    tipoAssistente: "apolices",
    tag: "",
    apiKey: "",
    descricao: "",
  });
  const [showApiKey, setShowApiKey] = useState(false);

  const [errors, setErrors] = useState({});

  const assistantTypes = [
    { value: "apolices", label: "Apólices", icon: MdPolicy },
    { value: "recibos", label: "Recibos", icon: IoReceiptSharp }
  ];

  const formatAssistantOption = ({ label, icon: Icon }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {Icon && <Icon size={18} color="#6b7280" />}
      <span>{label}</span>
    </div>
  );

  useEffect(() => {
      const style = document.createElement("style");
      style.innerHTML = `
        @keyframes spinModern {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
  
        .spin-modern {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 2px solid rgba(0,0,0,0.1);
          border-top: 2px solid #ebeaea;
          animation: spinModern 0.8s linear infinite;
        }
      `;
      document.head.appendChild(style);
  
      return () => {
        document.head.removeChild(style);
      };
   }, []);

 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Normalize tag: strip leading '@' while typing so we display prefix separately
    const newValue = name === "tag" ? value.replace(/^@+/, "") : value;
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData((prev) => ({
          ...prev,
          foto: file,
          fotoPreview: event.target.result,
        }));
      };
      reader.readAsDataURL(file);
      if (errors.foto) {
        setErrors((prev) => ({
          ...prev,
          foto: null,
        }));
      }
    }
  };

  const handleCreateIA = async (data) => {
    try {
      setLoading(true);

      const response = await createIAConfig({
        NOME: data.nome,
        FUNCAO: data.tipoAssistente,
        FOTO: data.foto,
        TAG: data.tag && String(data.tag).startsWith("@") ? data.tag : `@${data.tag}`,
        API_KEY: data.apiKey,
        DESCRICAO: data.descricao,
      });

      if (response?.type === "error") {
        setErrors({ tag: response.message });
        setLoading(false);
        return;
      }

      // If backend returns an explicit failure object, show message and stay
      // on the form instead of navigating away.
      if (response && response.success === false) {
        setErrors({ tag: response.message || "Erro ao criar assistente" });
        setLoading(false);
        return;
      }


      setErrors({});

   
      if (typeof onSubmit === "function") {
        try {
          onSubmit(response);
        } catch (e) {
          console.error("onSubmit handler threw:", e);
        }
      } else {
        navigate("/ais");
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao criar assistente");
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nome.trim()) {
      newErrors.nome = "Nome é obrigatório";
    }

    if (!formData.foto) {
      newErrors.foto = "Foto é obrigatória";
    }

    if (!formData.tipoAssistente) {
      newErrors.tipoAssistente = "Tipo de assistente é obrigatório";
    }

    if (!formData.tag.trim()) {
      newErrors.tag = "Tag é obrigatória";
    }

    // API Key is optional

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
        handleCreateIA({
            nome: formData.nome.trim(),
            foto: formData.foto,
            tipoAssistente: formData.tipoAssistente,
            tag: formData.tag.trim(),
            apiKey: formData.apiKey.trim(),
            descricao: formData.descricao.trim(),
        });
    }
  };

  const removeFoto = () => {
    setFormData((prev) => ({
      ...prev,
      foto: null,
      fotoPreview: null,
    }));
  };

  return (
    <div style={styles.container(isMobile)}>
      <div style={styles.headerSection(isMobile)}>
          <button
            onClick={() => navigate("/ais")}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              marginRight: 10,
              display: "flex",
              alignItems: "center"
            }}>
              <MdArrowBack size={24} />
          </button>


        <div style={styles.iconBadge}>
          <MdSmartToy size={24} />
        </div>

        <div>
          <h1 style={styles.title}>Novo Assistente de IA</h1>
          <p style={styles.subtitle}>
            Preencha os detalhes do novo assistente de IA
          </p>
        </div>
      </div>

      <div style={styles.formWrapper(isMobile)}>
        <form onSubmit={handleSubmit} style={styles.form}>
          {/* Nome */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Nome</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleInputChange}
              placeholder="Ex: Gemese IA, SuperBot..."
              style={styles.input}
              disabled={isLoading}
            />
            {errors.nome && (
              <span style={styles.errorText}>{errors.nome}</span>
            )}
          </div>

          {/* Foto */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Foto</label>
            <div style={styles.photoSection}>
              {formData.fotoPreview ? (
                  <div style={styles.photoPreviewWrapper(isMobile)}>
                    <img
                      src={formData.fotoPreview}
                      alt="Preview"
                      style={styles.photoPreview(isMobile)}
                    />
                    <button
                      type="button"
                      onClick={removeFoto}
                      style={styles.removePhotoButton}
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <label htmlFor="photoInput" style={styles.photoPlaceholder}>
                    <svg
                      style={styles.uploadIcon}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>

                    <p style={styles.photoPlaceholderText}>
                      Clique para enviar
                    </p>
                  </label>
                )}

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={styles.hiddenFileInput}
                  id="photoInput"
                  disabled={isLoading}
                />
            </div>
            {errors.foto && (
              <span style={styles.errorText}>{errors.foto}</span>
            )}
          </div>

         <Select
            value={assistantTypes.find(o => o.value === formData.tipoAssistente)}
            onChange={(selected) =>
              setFormData((prev) => ({
                ...prev,
                tipoAssistente: selected?.value || ""
              }))
            }
            options={assistantTypes}
            formatOptionLabel={formatAssistantOption}
            isSearchable={false}
            styles={{
              control: (base) => ({
                ...base,
                borderRadius: 8,
                borderColor: "#ccc",
                minHeight: 42,
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            isDisabled={isLoading}
          />

          {/* Tag */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Tag</label>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ padding: "8px 12px", background: "#f3f4f6", borderRadius: 6, border: "1px solid #e5e7eb" }}>@</span>
              <input
                type="text"
                name="tag"
                value={formData.tag}
                onChange={handleInputChange}
                placeholder="Ex: IA"
                style={{ ...styles.input, paddingLeft: 8 }}
                disabled={isLoading}
              />
            </div>
            {errors.tag && (
              <span style={styles.errorText}>{errors.tag}</span>
            )}
          </div>

          {/* API Key */}
          <div style={styles.formGroup}>
            <label style={styles.label}>API Key</label>
            <div style={styles.passwordInputWrapper}>
              <input
                type={showApiKey ? "text" : "password"}
                name="apiKey"
                value={formData.apiKey}
                onChange={handleInputChange}
                placeholder="Ex: sk-xxxxxxxxxxxxxxxxxxxx"
                style={{ ...styles.input, paddingRight: 50 }}
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={() => setShowApiKey((prev) => !prev)}
                style={styles.passwordToggleButton}
                disabled={isLoading}
                aria-label={showApiKey ? "Ocultar API Key" : "Mostrar API Key"}
              >
                {showApiKey ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
              </button>
            </div>
            {errors.apiKey && (
              <span style={styles.errorText}>{errors.apiKey}</span>
            )}
          </div>

          {/* Descrição */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Descrição</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleInputChange}
              placeholder="Descreva o propósito e funcionalidades do assistente..."
              style={styles.textarea}
              disabled={isLoading}
            />
            {errors.descricao && (
              <span style={styles.errorText}>{errors.descricao}</span>
            )}
          </div>

          {/* Botões */}
          <div style={styles.buttonGroup(isMobile)}>
            <button
                type="submit"
                style={{
                  ...styles.submitButton(isMobile),
                  opacity: loading || isLoading ? 0.7 : 1,
                  cursor: loading || isLoading ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8
                }}
                disabled={loading || isLoading}
              >
             {loading || isLoading ? (
                <>
                  <div className="spin-modern" />
                  A criar...
                </>
              ) : (
                "Criar Assistente"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AIAssistantForm;
